// import React from 'react';

interface ConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}

export default function ConfirmationDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Submit",
  cancelText = "Cancel"
}: ConfirmationDialogProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/45 px-4">
      <div className="w-full max-w-[486px] overflow-hidden rounded-[18px] bg-white shadow-[0_24px_80px_rgba(15,23,42,0.22)]">
        {/* Header */}
        <div className="bg-[#ECF6FF] px-6 py-4">
          <h3 className="text-center text-[18px] font-semibold text-[#2C8CFF]">{title}</h3>
        </div>
        
        {/* Content */}
        <div className="px-8 py-7">
          <p className="text-center text-[18px] leading-8 text-[#34415F]">{message}</p>
        </div>
        
        {/* Actions */}
        <div className="flex gap-5 px-8 pb-8">
          <button
            onClick={onClose}
            className="flex-1 rounded-lg border border-[#FFC8D8] bg-[#FFF0F4] px-4 py-3 font-medium text-[#FF2D75] transition-colors hover:bg-[#FFE5ED]"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 rounded-lg bg-[#FFC107] px-4 py-3 font-medium text-black transition-colors hover:bg-[#F2B400]"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
